import React from "react";
import {useTranslation} from "react-i18next";
import ReactDocumentTitle from "../../components/ReactDocumentTitle";
import Container from "../../ui/container";
import Layout, {Header, Main} from "../../components/Layout";
import classes from "./challenge-not-available.module.css";

type props = {
  reason?: "not-found" | "limits" | "expired";
};

export default function PlayerChallengeNotAvailableScene({reason}: props) {
  const {t} = useTranslation();

  let reasonMessage;

  switch (reason) {
    case "limits":
      reasonMessage = t("playerChallengeNotAvailable.limitsExceed");
      break;
    case "expired":
      reasonMessage = t("playerChallengeNotAvailable.expired");
      break;
    case "not-found":
    default:
      reasonMessage = t("playerChallengeNotAvailable.defaultReason");
  }

  return (
    <>
      <ReactDocumentTitle title={t("playerChallengeNotAvailable.title")} />
      <Layout className={classes.layoutRoot}>
        <Header type="transparent" />
        <Main>
          <Container>
            <div className={classes.root}>
              <h1 className={classes.h1}>{t("playerChallengeNotAvailable.h1")}</h1>
              <p className={classes.desc}>{reasonMessage}</p>
            </div>
          </Container>
        </Main>
      </Layout>
    </>
  );
}
